import Bugsnag from '@bugsnag/js';
Bugsnag.start({
  apiKey: '66f42ff4ebd3d2fe2615f0aabfd3ce58',
  releaseStage: __DEV__ ? 'development' : 'production',
  onError: function(event) {
    if (window.c5bugsnagBeforeNotify != null) {
      window.c5bugsnagBeforeNotify(event);
    }
  },
});

window.__bugsnag_as3_error = function(name, message) {
  if (__DEV__) {
    console.log(message);
  }
  Bugsnag.notify('AS3' + name, message, {}, 'error');
};
